<template>
	<div class="">
		<el-tabs v-model="status" @tab-click="handleClick" style="margin: 20px 0px 5px;">
			<el-tab-pane :label="$t('在借订单')" name="1"></el-tab-pane>
			<el-tab-pane :label="$t('历史订单')" name="2"></el-tab-pane>
		</el-tabs>
		<div class="list-page">
			<div class="th-div">
				<span class="column truncate1"></span>
				<span class="column truncate1">{{ $t('借款时间') }}</span>
				<span class="column truncate1">{{ $t('验资金额') }}</span>
				<span class="column truncate1">{{ $t('还款时间') }}</span>
				<span class="column truncate1">{{ $t('日币息率') }}</span>
				<span class="column truncate1">{{ $t('总服务费') }}</span>
				<span class="column truncate1">{{ $t('滞纳金百分比') }}</span>
				<span class="column truncate1">{{ $t('借币数量') }}</span>
				<span class="column truncate1">{{ $t('借币期限') }}</span>
				<span class="column truncate1">{{ $t('剩余时间') }}</span>
				<span class="column truncate1">{{ $t('当前币息') }}</span>
				<span class="column truncate1">{{ $t('滞纳金') }}</span>
				<span class="column truncate1">{{ $t('应还总额') }}</span>
			</div>
			<div class="tr-div" v-if="list.length > 0">
				<div class="row" v-for="value in list" :key="value.id">
					<span class="column">
						<div>
							<div style="color: #00f0ff;">{{ value.status_text }}</div>
							<div style="color: #fff;padding-top: 10px;">{{ value.order_sn }}</div>
						</div>
						<div class="boxCk" v-if="value.status == 2 || value.status == 3" @click="borrowRepay(value.id)">
							{{ $t('立即还款') }}</div>
					</span>
					<span class="column truncate1">{{ value.createtime_text }}</span>
					<span class="column truncate1">{{ value.money }}USDT</span>
					<span class="column truncate1">{{ value.repaytime_text }}</span>
					<span class="column truncate1">{{ value.daily_interest_rate * 100 }}%</span>
					<span class="column truncate1">{{ value.service_charge }}USDT</span>
					<span class="column truncate1">{{ value.late_rate * 100 }}%</span>
					<span class="column truncate1">{{ value.amount }}USDT</span>
					<span class="column truncate1">{{ value.period }}</span>
					<span class="column truncate1">{{ value.remanenttime }} {{ $t('天') }}</span>
					<span class="column truncate1">{{ value.interest_amount }} USDT</span>
					<span class="column truncate1">{{ value.late_amount }} USDT</span>
					<span class="column truncate1">{{ value.repay_amount }} USDT</span>
				</div>
			</div>
			<div class="dtk" v-else>{{ $t('没有更多数据了') }}</div>
		</div>

		<oPage v-if="page.total > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit"
			:total="page.total" @current-change="getdata" />
	</div>
</template>
<script>
import { get } from '@/http/request'
import apis from '@/http/api'
import oPage from '@/common/pc/oPage.vue'
export default {
	components: {
		oPage
	},
	data() {
		return {
			status: '1',
			list: [],
			page: {
				page: 1,
				limit: 10,
				total: 10,
			},
		};
	},
	created() {
		this.getdata()
	},
	watch: {
		status() {
			this.init()
		}
	},
	methods: {
		handleClick() { },
		init() {
			this.status == '1'
			this.page.page = 1
			this.getdata()
		},

		getdata(showLoading = false) {
			get(apis.getBorrowOrderList, {
				showLoading,
				...this.page,
				type: this.status - 1,
			}).then(res => {
				if (res.code != 1) return
				this.list = res.data.data
				this.page.total = res.data.total || 0
			})
		},
		async borrowRepay(id) {
			const res = await get(this.$apis.borrowRepay, { order_id: id })
			if (res.code == 1) {
				this.$notify.success(res.msg);
				setTimeout(() => {
					this.init()
				}, 800)
				return
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.list-page {
	overflow: auto;
	height: 600px;
	border: 2px solid #31323f;
	border-radius: 12px;
	// padding: 0 20px 20px;
	margin-bottom: 20px;
	position: relative;

	.tr-div {
		.row {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 2px;
			font-size: 14px;
			border-bottom: 1px solid #2c2c3e;
		}

		.boxCk {
			background-color: #404154;
			color: #fff;
			padding: 8px 16px;
			border-radius: 10px;
			display: inline-block;
			font-size: 12px;
		}
	}

	.th-div {
		height: 60px;
		line-height: 60px;
		font-size: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 2px;
		color: #fff;
		border-bottom: 1px solid #2c2c3e;
	}

	.column {
		flex: 1;
		min-height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dtk {
		width: 100%;
		height: 100px;
		line-height: 100px;
		text-align: center;
		color: #888;
	}
}
</style>